import { changeIpv4Contrato, useUpdateContrato, useUpdateNaps } from "@/shared/actions/erp";
import { Contrato, OrdenTrabajo, PuertoNap } from "@/shared/interfaces";
import { useQueryClient } from "@tanstack/react-query";
import { UseFormReturn } from "react-hook-form";
import { toast } from "react-toastify";

type useSaveActivacionProps = {
    ordenTrabajo: OrdenTrabajo;
    form?: UseFormReturn<any>
}

function useSaveActivacion({ ordenTrabajo, form }: useSaveActivacionProps) {
    /**Globals */
    const queryClient = useQueryClient();

    /**Fetchs */
    const setNapDataNoReturn = useUpdateNaps({
        enableRedirect:false
    });

    // const setOrdenTrabajoNoReturn = useUpdateOrdenTrabajo<Partial<OrdenTrabajo>>({
    //     enableRedirect: false
    // });
    const setContratoDataNoReturn = useUpdateContrato<Partial<Contrato>>({
        enableRedirect:false
    });

    const cambioDeNap = async () => {
        if(!form?.getValues()?.campos_completados){
            throw new Error("Debe completar todos los DATOS TÉCNICOS para realizar el cambio de nap")
        }
        if(!ordenTrabajo?.nap_data?.puertos 
            || !form?.getValues()?.rawNap?.puertos){
            throw new Error("Problema con puertos de la NAP seleccionada");
        }
        const puertoNapAnterior = ordenTrabajo.nap_data.puertos.find(x=>x.puerto == ordenTrabajo?.puerto)
        const puertoNapObjetivo = form.getValues().rawNap.puertos?.find((x:PuertoNap)=>x.puerto == form?.getValues()?.puerto)
        if(!ordenTrabajo?.nap_data?.puertos){
            throw new Error("Problema con puertos previos");
        } 

        const newPuertosNapAnterior: PuertoNap[] = ordenTrabajo.nap_data.puertos.map((x:PuertoNap)=>{
            if(x?.puerto == puertoNapAnterior?.puerto){
                return {
                    puerto: x.puerto,
                    estado: "DISPONIBLE",
                    id_cliente_contrato: null
                } as PuertoNap
            }
            return x as PuertoNap
        })
        const newPuertosNapActual: PuertoNap[] = form.getValues().rawNap.puertos.map((x:PuertoNap)=>{
            if(x?.puerto == puertoNapObjetivo?.puerto){
                return {
                    puerto: x.puerto,
                    estado: "OCUPADO",
                    id_cliente_contrato: ordenTrabajo?.contrato_data?.id_contrato||null
                } as PuertoNap
            }
            return x as PuertoNap
        })
        await setNapDataNoReturn.mutateAsync({
            id:ordenTrabajo?.nap_data?.id_nap!,
            data:{
            puertos:newPuertosNapAnterior,
            }
        })
        await setNapDataNoReturn.mutateAsync({
            id:form.getValues().rawNap.id_nap!,
            data:{
            puertos:newPuertosNapActual,
            }
        })
        
    }
    const cambioPuertoDeNap = async () => {
        if(!form?.getValues()?.campos_completados){
            throw new Error("Debe completar todos los DATOS TÉCNICOS para realizar el cambio de puerto de la nap")
        }
        if(!ordenTrabajo?.nap_data?.puertos){
            throw new Error("Problema con puertos previos");
        }

        const newPuertosNap: PuertoNap[] = ordenTrabajo.nap_data!.puertos!.map((x:PuertoNap)=>{
            if(x?.puerto == form?.getValues()?.puerto){
                return {
                puerto: x.puerto,
                estado: "OCUPADO",
                id_cliente_contrato: ordenTrabajo?.contrato_data?.id_contrato||null
                } as PuertoNap
            }
            if(x?.puerto == ordenTrabajo?.puerto){
                return {
                puerto: x.puerto,
                estado: "DISPONIBLE",
                id_cliente_contrato: null
                } as PuertoNap
            }
            return x as PuertoNap
        })
        await setNapDataNoReturn.mutateAsync({
            id:ordenTrabajo?.nap_data?.id_nap!,
            data:{
                puertos:newPuertosNap,
            }
        })

    }

    const cambiarIPv4 = async() => {
        if(!form?.getValues()?.campos_completados){
            throw new Error("Debe completar todos los DATOS TÉCNICOS para realizar el cambio de ipv4")
        }
        if(!form?.getValues()?.es_bras && !form?.getValues()?.router){
            toast.error("Debe seleccionar un router")
            return
        }
        const newIpRes = await changeIpv4Contrato({
            contrato_codigo: ordenTrabajo?.contrato_data?.codigo||"",
            router_codigo: form?.getValues()?.router
          })
          if(newIpRes?.code==200){
            queryClient.invalidateQueries({
              queryKey: ["orden-trabajo", ordenTrabajo?.id_orden_trabajo],
            })
            form?.setValue("ipv4_actual", newIpRes?.data?.ipv4_actual || "")
            form?.setValue("ont_a_utilizar", null)
            toast.success("IPv4 cambiado exitosamente")
          }else{
            toast.error("Error al cambiar el IPv4")
        }
        return newIpRes
    }

    const cambiarRouter = async() => {
        if(!form?.getValues()?.campos_completados){
            throw new Error("Debe completar todos los DATOS TÉCNICOS para realizar el cambio de router")
        }
        const contratoUpdated = await setContratoDataNoReturn.mutateAsync({
            id: ordenTrabajo?.contrato_data?.id_contrato!,
            data: {
                router: form?.getValues()?.router
            }
        })
        if(
            contratoUpdated?.code == 200
            // && ordenTrabajoUpdated?.code == 200
        ){
            toast.success("Router cambiado exitosamente")
            return true
        }else{
            toast.error("Error al cambiar el router")
            return false
        }
    }

    return {
        cambioDeNap,
        cambioPuertoDeNap,
        cambiarIPv4,
        cambiarRouter
    }
}

export default useSaveActivacion